import { FunctionComponent } from 'react'
import { ArrayLocationAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { Chip } from '@black-bear-energy/rucksack'

type ArrayLocationChipColor =
  | 'info'
  | 'secondary'
  | 'primary'
  | 'success'
  | 'warning'
  | 'default'

export type ArrayLabelVariant = 'full' | 'abbreviation'

export function getArrayLocationLabel(
  arrayLocation: ArrayLocationAPIResponse,
  labelVariant: ArrayLabelVariant = 'full'
): string {
  const { label, abbreviation } = ARRAY_LOCATION_PROPERTIES[arrayLocation]
  return labelVariant === 'abbreviation' ? abbreviation : label
}

const ARRAY_LOCATION_PROPERTIES: Record<
  ArrayLocationAPIResponse,
  { label: string; abbreviation: string; color: ArrayLocationChipColor }
> = {
  rooftop: {
    label: 'Rooftop',
    abbreviation: 'R',
    color: 'info',
  },
  carport: {
    label: 'Carport',
    abbreviation: 'C',
    color: 'secondary',
  },
  parktop: {
    label: 'Parktop',
    abbreviation: 'P',
    color: 'primary',
  },
  ground: {
    label: 'Ground',
    abbreviation: 'G',
    color: 'success',
  },
  storage: {
    label: 'Storage',
    abbreviation: 'S',
    color: 'warning',
  },
  roofAndCarport: {
    label: 'Roof + Carport',
    abbreviation: 'R+C',
    color: 'default',
  },
  roofAndParktop: {
    label: 'Roof + Parktop',
    abbreviation: 'R+P',
    color: 'default',
  },
  carportAndParktop: {
    label: 'Carport + Parktop',
    abbreviation: 'C+P',
    color: 'default',
  },
  roofAndCarportAndParktop: {
    label: 'Roof + Carport + Parktop',
    abbreviation: 'R+C+P',
    color: 'default',
  },
}

export const ArrayLocationChip: FunctionComponent<ArrayLocationChipProps> = ({
  arrayLocation,
  scale = 'medium',
}) => {
  const { color } = ARRAY_LOCATION_PROPERTIES[arrayLocation]

  return (
    <Chip
      label={getArrayLocationLabel(
        arrayLocation,
        scale === 'medium' ? 'full' : 'abbreviation'
      )}
      color={color}
      variant="outlined"
      size={scale === 'mini' ? 'mini' : 'small'}
    />
  )
}

interface ArrayLocationChipProps {
  arrayLocation: ArrayLocationAPIResponse
  scale?: 'medium' | 'mini'
}
